// Utility functions for normalizing BAC values

/**
 * Convert a value coming from JSON into a BigInt BAC.
 * Strings are parsed, numbers are coerced, and invalid inputs return undefined.
 */
export const parseBAC = (value) => {
  if (value === null || value === undefined || value === '') return undefined;
  try {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  } catch (e) {
    // Fallback: try Number conversion then to BigInt
    const num = Number(value);
    if (Number.isNaN(num)) return undefined;
    const parsed = parseInt(num, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  }
};

/**
 * Safely convert a BAC value (BigInt or number) to a string for API calls.
 */
export const bacToString = (bac) =>
  bac !== undefined && bac !== null ? bac.toString() : '';
